import type { RequestStatus } from '@shared';

const META: Record<RequestStatus, { label: string; tone: 'neutral' | 'amber' | 'accent' | 'green'; step: number }> = {
  submitted:  { label: 'Submitted',  tone: 'neutral', step: 0 },
  reviewing:  { label: 'Reviewing',  tone: 'amber',   step: 1 },
  engagement: { label: 'Engagement', tone: 'accent',  step: 2 },
  delivered:  { label: 'Delivered',  tone: 'green',   step: 3 },
  closed:     { label: 'Closed',     tone: 'neutral', step: 4 },
};

export function StatusChip({ status }: { status: RequestStatus }) {
  const m = META[status];
  const cls = m.tone === 'accent' ? 'accent' : m.tone === 'amber' ? 'amber' : m.tone === 'green' ? 'green' : '';
  return (
    <span className={`chip ${cls}`}>
      <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'currentColor' }} />
      {m.label}
    </span>
  );
}

export function StatusBar({ status }: { status: RequestStatus }) {
  const order: RequestStatus[] = ['submitted', 'reviewing', 'engagement', 'delivered', 'closed'];
  const cur = META[status].step;
  return (
    <div className="statusbar">
      {order.map((s, i) => (
        <div key={s} className={`step ${i < cur ? 'done' : i === cur ? 'now' : ''}`}>
          {String(i + 1).padStart(2, '0')} {META[s].label}
        </div>
      ))}
    </div>
  );
}

export function statusLabel(status: RequestStatus): string { return META[status].label; }
